/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Success_BodyInputs */

const tr_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek ekibi genellikle 1 iş günü içinde dönüş yapıyor. Aynı konuda tekrar yazman gerekirse yine buradan ulaşabilirsin.`)
};

const en_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The support team usually replies within 1 business day. If you need to write again about the same topic, you can reach us here.`)
};

const de_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Support-Team antwortet in der Regel innerhalb eines Arbeitstags. Falls Sie zum gleichen Thema noch einmal schreiben müssen, können Sie uns hier erneut erreichen.`)
};

const ru_contact_form_success_body = /** @type {(inputs: Contact_Form_Success_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Служба поддержки обычно отвечает в течение одного рабочего дня. Если вам нужно написать снова по этому же вопросу, вы можете сделать это здесь.`)
};

/**
* | output |
* | --- |
* | "The support team usually replies within 1 business day. If you need to write again about the same topic, you can reach us here." |
*
* @param {Contact_Form_Success_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_success_body = /** @type {((inputs?: Contact_Form_Success_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Success_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_success_body(inputs)
	if (locale === "de") return de_contact_form_success_body(inputs)
	if (locale === "ru") return ru_contact_form_success_body(inputs)
	return tr_contact_form_success_body(inputs)
});